import type { Permission } from "./statement";

/** A colleague's HR file. Every floor role holds hr:read for its own file, so a colleague's takes
 * managing HR, or reading the team (staff:read) as well, where the colleague works. */
export function seesTeamHr(holds: (permission: Permission) => boolean): boolean {
  return holds("hr:manage") || (holds("hr:read") && holds("staff:read"));
}
